import React, { useRef } from 'react';

import { Box, Heading, Text, ButtonPrimary, BorderBox, TextInput } from '@primer/components'
import { useSearchRepositories } from '../../hooks/useOctokit'
import { Search } from '@primer/octicons-react'
import { Facebook, Twitter, Mail, Whatsapp } from 'react-social-sharing'

import RepositorySearchResult from '../RepositorySearchResult'
import RateLimited from '../RateLimited'
import Advice from '../Advice'


const resultsStyles = {
  background: 'white',
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
  marginTop: '-4px',
  maxHeight: '400px',
  overflowY: 'auto',
}

export default function(props) {
  const scollToRef = useRef()

  React.useEffect(() => {
    // only scroll to top when viewing full summary
    if (props.showMini) {
      scollToRef.current.scrollIntoView()
    } else {
      window.scrollTo(0, 0)
    }
  }, []);
  const shareMessage = `I fixed ${props.issuesFixed} of ${props.totalIssues} Django anti-patterns`

  return (
    <Box className="col-12" ref={scollToRef}>
      <Box>
        <Text as="h3" className="mt-4">You found and fixed {props.issuesFixed} of {props.totalIssues} issues. Here's what you missed:</Text>
        { 
          props.messageIds.map(messageId => (
            <Advice
              messageId={messageId}
              style={{borderTop: 'none'}}
              items={[]}
              defaultOpen={false}
              showInstallPrompt={false}
              showDiff={false}
              showLink={false}
              showHeaderCount={true}
            />
          ))
        }
        <Text as={"p"} className="mt-6">Share your score</Text>
        <Twitter link={window.location.href} message={shareMessage} />
        <Facebook link={window.location.href} message={shareMessage} />
        <Whatsapp link={window.location.href} message={shareMessage} />
        <Mail link={window.location.href} subject={shareMessage} />
      </Box>
      {!props.showMini && <Upsell {...props} />}
    </Box>
  )
}


function Upsell(props) {
  const [updateSerachParams, searchParams, repositories, retrievingRepositories, repositoriesTotalCount, isRateLimited] = useSearchRepositories()

  return (
      <BorderBox className="p-4 mt-10 bg-gray">
        <Box className="">
          <Heading>How to improve?</Heading>
          <Text as="p">Code Review Doctor improves your Django security, performance, and maintainability. Review your codebase:</Text>
          <Box className="mb-4">
            <TextInput
              onChange={event => updateSerachParams({q: event.target.value})}
              name="repository"
              placeholder="Type repo name or paste github link"
              className="bg-white col-12 f3 pt-2 pb-2"
              icon={Search}
              autoFocus
            />
            <RateLimited show={isRateLimited} />
            <RepositorySearchResult repositories={repositories} style={resultsStyles} showOwner={false} />
          </Box>
          <div className="position-relative" style={{width: '100%', height: 0, paddingBottom: '56.25%'}}>
            <iframe
              title="Code Review Doctor removes tech debt"
              src="https://www.youtube-nocookie.com/embed/MtxqbmyPl6Y"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="position-absolute"
              style={{top: 0, left: 0, width: '100%', height: '100%'}}
            />
          </div>
        </Box>

        <Box style={{textAlign: 'center'}}>
          <ButtonPrimary
            as="a"
            href="https://github.com/marketplace/django-doctor/"
            variant="large"
            className="mt-6 mb-3"
          >Start fixing tech debt</ButtonPrimary>
        </Box>

        <Box className="mt-4">
          <Text as="p" className="mb-4">Or install our <a href="https://github.com/marketplace/django-doctor/">GitHub bot</a> to prevent them getting into your codebase</Text>
          <div className="position-relative" style={{width: '100%', height: 0, paddingBottom: '56.25%'}}>
            <iframe
              title="Code Review Doctor reviews pull request"
              src="https://www.youtube-nocookie.com/embed/28ZCSSDaNnc"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="position-absolute"
              style={{top: 0, left: 0, width: '100%', height: '100%'}}
            />
          </div>
        </Box>
        <Box style={{textAlign: 'center'}}>
          <ButtonPrimary
            as="a"
            href="https://github.com/marketplace/django-doctor/"
            variant="large"
            className="mt-6 mb-3"
          >Get our GitHub bot</ButtonPrimary>
        </Box>
      </BorderBox>
    )
}